const ApiConfigs = {
	GET_BUSINESS: {
		method: "get",
		url: "/biz_config/app",
	},
	GET_COVERAGE: {
		method: "post",
		url: "/mobile_broadband/coverage"
	},
	CONFIRM_COVERAGE: {
		method: "post",
		url: "/mobile_broadband/details"
	},
	GET_COVERAGE_DETAILS: {
		method: "get",
		url: "/mobile_broadband/details"
	},
	GET_PLANS_BY_PRODUCT: {
		method: "get",
		url: "/products/available_plans", //?product_codes=" + code + "&service_types=1,3,4,10
	}
};

const getAPIConfig = (name, data) => {
	return {...ApiConfigs[name], data: data}
};

export { getAPIConfig };
